module.exports = __webpack_public_path__ + "static/media/wuyi_bg4.7345edb4.jpg";